import { render, staticRenderFns } from "./TerrenoConstruccion.vue?vue&type=template&id=1fa0616a&scoped=true&lang=html&"
import script from "./TerrenoConstruccion.vue?vue&type=script&lang=js&"
export * from "./TerrenoConstruccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa0616a",
  null
  
)

export default component.exports